import { render } from "./QuestInProgressV2Page.vue?vue&type=template&id=8f96e878&scoped=true"
import script from "./QuestInProgressV2Page.vue?vue&type=script&lang=js"
export * from "./QuestInProgressV2Page.vue?vue&type=script&lang=js"

import "./QuestInProgressV2Page.vue?vue&type=style&index=0&id=8f96e878&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f96e878"]])

export default __exports__